import { normalizeNumber } from "@/views/PageDashboard/helpers";
import { ListField } from "@/types";
import { $t } from "@/lib/helpers/i18nHelper";

export enum COLORS {
  PINK = "#ef5da8",
  LILAC = "#a5a6f6",
  BLUE = "#61a1f6",
  GREEN = "#83eac1",
  GRAY = "#bdbdbd",
  WHITE = "#ffffff",
}

export const ScalesConfig = {
  x: {
    drawOnChartArea: false,
    drawTicks: false,
    tickLength: 10,
    tickWidth: 12,
    grid: {
      borderColor: COLORS.GRAY,
      drawOnChartArea: false,
      tickWidth: 1,
      tickColor: COLORS.GRAY,
    },
  },
  y: {
    beginAtZero: true,
    grid: {
      borderColor: COLORS.GRAY,
      borderDash: [4],
      lineWidth: 0.5,
      tickColor: COLORS.GRAY,
      tickWidth: 1,
    },
    ticks: {
      callback: (val: string | number) => normalizeNumber(Number(val)),
    },
  },
};

export const ToolTipConfig = {
  titleFont: {
    weight: "normal",
  },
  titleMarginBottom: 2,
  displayColors: false,
};

export const preparedDate = {
  LAST_WEEK: null,
  LAST_TWO_WEEK: "lastTwoWeek",
  THIS_MONTH: "thisMonth",
  LAST_MONT: "lastMonth",
  THIS_QUARTER: "thisQuarter",
  LAST_QUARTER: "lastQuarter",
  LAST_MONTH: "lastMonth",
  THIS_YEAR: "thisYear",
  LAST_YEAR: "lastYear",
  CUSTOM: "custom",
};

export const showList: ListField[] = [
  { text: $t("Last 7 days"), value: preparedDate.LAST_WEEK },
  { text: $t("Last 14 days"), value: preparedDate.LAST_TWO_WEEK },
  { text: $t("This month"), value: preparedDate.THIS_MONTH },
  { text: $t("Last month"), value: preparedDate.LAST_MONTH },
  { text: $t("This quarter"), value: preparedDate.THIS_QUARTER },
  { text: $t("Last quarter"), value: preparedDate.LAST_QUARTER },
  { text: $t("This year"), value: preparedDate.THIS_YEAR },
  { text: $t("Last year"), value: preparedDate.LAST_YEAR },
  { text: $t("Custom"), value: preparedDate.CUSTOM },
];
